import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { kendoIcons } from '@app/shared/library/kendo-icons';
import { ButtonDirective } from '@progress/kendo-angular-buttons';
import { IScopingItemGroupMapping } from '../../models/iscoping-item-group-mapping';
import { DragDropDependentItemComponent } from '../drag-drop-dependent-item/drag-drop-dependent-item.component';
import { DragDropItemBaseComponent } from '../drag-drop-item-base/drag-drop-item-base.component';

@Component({
  selector: 'app-drag-drop-scoping-item',
  templateUrl: './drag-drop-scoping-item.component.html',
  styleUrls: ['./drag-drop-scoping-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    ButtonDirective,
    DragDropDependentItemComponent,
  ],
})
export class DragDropScopingItemComponent extends DragDropItemBaseComponent {
  readonly group = input<IScopingItemGroupMapping>(undefined);

  public icons = kendoIcons;

  constructor() {
    super();
  }
}